<template>
  <Authenticated>
    <div class="header">
      <h2>Settings</h2>
    </div>

    <div class="payment_options">
      <form @submit.prevent>
        <h3>Company Details</h3>
        <header class="header">
          <span>
            <input type="text" :value="companySettings.company_name" id="name" class="detail" placeholder="Legal Entity" @click.stop.prevent="this.editName = true" />
            <font-awesome-icon v-if="editName" icon="floppy-disk" class="edit blue" @click.stop.prevent="saveName" />
          </span>
          <span>
            <input type="text" :value="companySettings.gst" id="gst" class="detail" placeholder="GST number" @click.stop.prevent="this.editGst = true"  />
            <font-awesome-icon v-if="editGst" icon="floppy-disk" class="edit blue" @click.stop.prevent="saveGst" />
          </span>
        </header>
        <section class="section">
          <h3>Trading Details</h3>
          <ul class="grid wrapper">
            <li class="modifierBox">
              <label for="training_enable">Enable Training:</label>
              <ToggleSwitch :modelName="'training_enable'" :modelValue="training_enable" @update:modelValue="enableTraining" />
            </li>
            <li class="modifierBox">
              <label for="cogs_enable">Enable COGS:</label>
              <ToggleSwitch :modelName="'cogs_enable'" :modelValue="cogs_enable" @update:modelValue="enableCogs" />
            </li>
            <li class="modifierBox">
              <label for="kds_enable">Enable KDS:</label>
              <ToggleSwitch :modelName="'kds_enable'" :modelValue="kds_enable" @update:modelValue="enableKds" />
            </li>
            <li class="modifierBox">
              <label for="pos_enable">Enable POS:</label>
              <ToggleSwitch :modelName="'pos_enable'" :modelValue="pos_enable" @update:modelValue="enablePos" />
            </li>
            <li class="modifierBox">
              <label for="sat_enable">Enable Satellite:</label>
              <ToggleSwitch :modelName="'sat_enable'" :modelValue="sat_enable" @update:modelValue="enableSat" />
            </li>
            <li class="modifierBox" @click.stop.prevent="openTZModal">
              <label for="timeZone">Time Zone:</label>
              <div>
                <p class="blue">{{ timezone }}</p>
              </div>
            </li>
            <li class="modifierBox">
              <label for="currency">Currency:</label>
              <p v-if="getCurrencySymbol" class="selected-currency blue">{{ getCurrencySymbol }} {{ savedCurrency.currency }}</p>
              <!-- <select @change="saveCurrency" name="currency" id="currency" class="currency">
                <option value="Select Currency" selected>Select Currency</option>
                <option v-for="(currency, idx) in currencies" :key="currency + idx"> {{ currency.symbol }} - {{ currency.currency }} </option>
              </select> -->
              <Carousel :items="currencyOptions" :style="'arrow'" title="Choose Currency" @select-item="saveCurrency" />
            </li>
            <li class="modifierBox">
              <p>Xero:</p>
              <sub class="blue">Connect to Xero for accounting and payroll management.</sub>
              <button type="button" v-if="!companySettings.xero_linked" class="blue" @click.stop.prevent="$router.push('/settings/xero')">Connect</button>
              <button type="button" v-if="companySettings.xero_linked" class="blue" @click.stop.prevent="$router.push('/settings/xero')">Manage Connection</button>
            </li>
            <li class="modifierBox">
              <p>Stripe:</p>
              <sub class="blue">Connect to Stripe for online payment processing.</sub>
              <button class="blue" @click.stop.prevent="connectToStripe" v-if="!companySettings.stripe_linked">Connect</button>
              <button class="blue" @click.stop.prevent="stripe_get_account_details" v-else>Manage Connection</button>
            </li>
            <li class="modifierBox">
              <p>Billing:</p>
              <sub class="blue">Manage your billing information and payment methods.</sub>
              <button class="blue" v-if="companySettings.stripe_subscribed" @click.stop.prevent="$router.push('/settings/payments')">Manage</button>
              <button class="blue" v-else @click.stop.prevent="$router.push('/settings/payments')">Subscribe</button>
            </li>
          </ul>
        </section>

        <section class="section">
          <h3>Locations</h3>
          <ul class="grid wrapper">
            <li class="modifierBox" v-for="site in siteMap" :key="site" @click.stop.prevent="$router.push(`/settings/${site.site}`)">
              <p v-if="site.site_name != ''">{{ site.site_name }}</p>
              <p v-else class="site-name">{{ site.site }}</p>
            </li>
            <li v-if="!createSite" class="add" @click.stop.prevent="createSite = !createSite">Add Site</li>
            <li v-if="createSite" class="modifierBox add-site">
              <h3>Add Site</h3>
              <p class="errors" v-if="errors">{{ errors }}</p>
              <input type="text" v-model="newSite" placeholder="Site Name" />
              <button type="button" class="action-colour" @click.stop.prevent="addSite">Add</button>
            </li>
          </ul>
        </section>

        <section class="section">
          <h3>Users</h3>
          <ul class="grid wrapper">
            <li class="modifierBox" v-for="user in users" :key="user">
              <!-- <p class="reduce">{{ user.value.name }}</p> -->
              <p class="wrap">{{ user.value.user }}</p>
              <button type="button" class="delete danger" @click.stop.prevent="showConfirm = true">Delete user</button>
            </li>
            <li v-if="!addNewUser" class="add" @click.stop.prevent="addUser">Add User</li>
            <li v-if="addNewUser" class="modifierBox new-user">
              <label for="newUser">New User:</label>
              <input type="text" placeholder="Name" v-model="newUser.name" />
              <input type="text" placeholder="Email" v-model="newUser.user" />
              <select name="roles" id="" v-model="newUser.roles">
                <option value="" selected>Choose Roles</option>
                <option value="admin">Admin (access all)</option>
                <option value="station">Standard (access to station)</option>
              </select>
              <button type="button" class="action-colour" @click.stop.prevent="saveUser">Invite user</button>
            </li>
          </ul>
        </section>

      </form>
    </div>
    <Confirm :open="showConfirm" :message="'Are you sure you want to delete this user'" @confirmModal="deleteUser" />
    <TZModal :open="showTZModal" />
  </Authenticated>
</template>

<script>
// import Discounts from '@/components/Discounts/Discounts.vue'
import Authenticated from "@/components/_layouts/Authenticated";
import { Confirm, Carousel, ToggleSwitch  } from "@monolith/components";
import TZModal from "./TZModal.vue";
import { api } from "@monolith/helpers";
import { mapGetters } from "vuex";
import Slug from "slug";

export default {
  name: "Modifiers",
  components: {
    Authenticated,
    TZModal,
    ToggleSwitch,
    Confirm,
    Carousel,
  },

  // setup: {
  //   provide("station", this.station),
  // },

  data() {
    return {
      createSite: false,
      newSite: "",
      users: [],
      addNewUser: false,
      showConfirm: false,
      newUser: {
        name: "",
        user: "",
        roles: "",
      },
      currencies: [
        {
          currency: "AUS",
          symbol: "$",
        },
        {
          currency: "NZD",
          symbol: "$",
        },
        {
          currency: "GBP",
          symbol: "£",
        },
      ],
      currencyOptions: [
        { value: "AUS", name: "AUS - $" },
        { value: "NZD", name: "NZD - $", selected: true },
        { value: "GBP", name: "GBP - £" },
      ],
      savedCurrency: { currency: "", symbol: "" },
      kds_enable: false,
      pos_enable: false,
      cogs_enable: false,
      training_enable: false,
      sat_enable: false,
      showSiteModal: false,
      showKDSModal: false,
      showPOSModal: false,
      showTZModal: false,
      showCompanionModal: false,
      POSStation: null,
      companionStation: null,
      KDSStation: null,
      newStation: false,
      settings: null,
      station: "",
      timer: null,
      editGst: false,
      editName: false,
      site: "",
      activeIndex: null,
      currentSite: {},
      errors: false,
    };
  },

  computed: {
    ...mapGetters({
      channels: "channels",
      siteMap: "siteMap",
      siteSettings: "siteSettings",
      companySettings: "companySettings",
      timezone: "timezone",
      sites: "sites",
      cogsEnabled: "cogsEnabled",
      currency: "currency",
    }),

    getCurrencySymbol() {
      if (!this.companySettings.currency) return false;
      return this.currencies.find((currency) => currency.currency == this.companySettings.currency).symbol;
    },

    existingSites() {
      return this.siteMap.map((site) => site.site);
    },

    getSavedCurrency() {
      let found = {currency: this.companySettings.currency, symbol: this.getCurrencySymbol};
      return found;
    },
  },

  async mounted() {
    this.cogs_enable = this.companySettings.cogs_enable;
    this.pos_enable = this.companySettings.pos_enable;
    this.kds_enable = this.companySettings.kds_enable;
    this.sat_enable = this.companySettings.sat_enable;
    this.training_enable = this.companySettings.training_enable;
    this.users = await api.get_users();
    let foundCurrency =  {currency: this.companySettings.currency, symbol: this.getCurrencySymbol};
    this.savedCurrency = foundCurrency;
    // this.savedCurrency = this.getSavedCurrency();
  },

  methods: {
    async connectToStripe() {
      this.$notify({
        type: "success",
        title: "This functionality is in development",
        text: "You will be able to connect to Stripe soon!",
        duration: 5000,
      })
      // let result = await api.initilise_stripe_connect(this.companySettings.company_slug);
      // window.location.href = result.url;
    },

    async stripe_get_account_details() {
      await api.stripe_get_account_details();
    },

    async getTokens() {
      await api.get("/api/company/get_xero_tokens");
    },

    async getTaxTypes() {
      await api.get_xero_tax_types();
    },

    async getOrgDetails() {
      await api.get_xero_organisation_details();
    },

    async integrate_with_xero() {
      let result = await api.integrate_with_xero();
      window.location.href = result.url;
    },

    async addSite() {
      if (!this.newSite) {
        this.errors = "Please enter a site name";
        return;
      }
      if (this.existingSites.includes(Slug(this.newSite))) {
        this.errors = "Site aready exists";
        return;
      }
      await api.add_site(Slug(this.newSite), this.newSite);
      this.newSite = "";
      this.createSite = false;
    },

    deleteUser() {
      this.showConfirm = false;
    },
    addUser() {
      this.addNewUser = true;
    },

    saveUser() {
      api.add_new_user(this.newUser);
      this.addNewUser = false;
    },

    dropDown(idx) {
      this.activeIndex = this.activeIndex === idx ? null : idx;
    },

    async enableCogs() {
      this.cogs_enable = !this.cogs_enable;
      api.save_company_settings("cogs_enable", this.cogs_enable);
      await this.$store.dispatch("getSettings");
    },

    async enableKds() {
      this.kds_enable = !this.kds_enable;
      api.save_company_settings("kds_enable", this.kds_enable);
      await this.$store.dispatch("getSettings");
    },

    async enableTraining() {
      this.training_enable = !this.training_enable;
      api.save_company_settings("training_enable", this.training_enable);
      await this.$store.dispatch("getSettings");
    },

    async enablePos() {
      this.pos_enable = !this.pos_enable;
      api.save_company_settings("pos_enable", this.pos_enable);
      await this.$store.dispatch("getSettings");
    },

    async enableSat() {
      this.sat_enable = !this.sat_enable;
      api.save_company_settings("sat_enable", this.sat_enable);
      await this.$store.dispatch("getSettings");
    },

    openTZModal() {
      this.showTZModal = true;
    },

    saveGst() {
      let gst = document.getElementById("gst").value;
      api.save_company_settings("gst", gst);
      this.editGst = false;
      this.$store.dispatch("getSettings");
    },

    async saveCurrency(option) {
      let selectedCurrency = option; // Use the selected value from the Carousel component
      // let selectedCurrency = document.getElementById("currency").value;
      this.currencies.find((currency) => {
        // if(currency.currency == selectedCurrency){
        if (currency.currency == selectedCurrency.split(" - ")[0]) {
          this.savedCurrency.currency = currency.currency;
          this.savedCurrency.symbol = currency.symbol;
        }
      });
      this.$store.dispatch("setCompanyCurrency", this.savedCurrency);
      await api.save_company_settings("currency", this.savedCurrency.currency).then(() => {
        this.$store.dispatch("getSettings");
      });
      // this.$store.dispatch("getSettings");
    },

    saveName() {
      let name = document.getElementById("name").value;
      api.save_company_settings("company_name", name);
      this.editName = false;
      this.$store.dispatch("getSettings");
    },
  },

  // watch: {
  //   cogs_enable: {
  //     handler() {
  //       if (this.cogs_enable != this.companySettings.cogs_enable) {
  //         this.enableCogs();
  //       }
  //     },
  //     deep: true,
  //   },
  // },
};
</script>
<style scoped lang="scss">
@use "@monolith/styles";

.blue {
  color: var(--action-colour);
  text-align: center;
}

.site-name {
  cursor: pointer;
  text-transform: capitalize;
}

h2{
  margin-left: 1rem;
}

ul.wrapper {
  background-color: var(--primary-colour);
  box-shadow: var(--box-shadow);
  .modifierBox {
    background-color: var(--tertiary-colour);
    border-color: var(--tertiary-colour);
    box-shadow: var(--box-shadow);
  }
}

form {
  label {
    display: contents;
  }
  .blue {
    color: var(--action-colour);
    cursor: pointer;
  }

  .add {
    background-color: var(--action-colour);
    color: var(--secondary-text-colour) !important;
    cursor: pointer;
    margin: 0.5rem;
    padding: 0.5rem;
    border-radius: 0.25rem;
    box-shadow: var(--box-shadow);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .sites {
    display: flex;
    flex-direction: column;
    background: var(--primary-colour);
    box-shadow: var(--box-shadow);
    border-radius: 10px;
    margin: 1rem;
    padding: 1rem;
  }

  .wrap {
    text-wrap: wrap;
  }

  .new-user {
    label {
      margin: 0.5rem;
    }
    input {
      background-color: var(--primary-colour);
      box-shadow: var(--box-shadow);
      border: none;
      border-radius: 5px;
      font-size: 1.25rem;
      color: var(--text-colour);
      margin: 0.5rem;
      padding: 0.25rem;
    }
    button {
      background-color: var(--action-colour);
      color: var(--secondary-text-colour);
      padding: 0.25rem 2rem;
      border-radius: 5px;
      margin: 0.5rem;
    }
    select {
      background-color: var(--primary-colour);
      box-shadow: var(--box-shadow);
      border: none;
      border-radius: 5px;
      color: var(--text-colour);
      margin: 0.5rem;
      padding: 0.5rem;
    }
  }

  .add-site {
    display: flex;
    flex-direction: row;
    align-items: center;
    h3 {
      margin: 0.25rem 0 0.25rem 1rem;
    }
    input {
      background-color: var(--primary-colour);
      box-shadow: var(--box-shadow);
      border-radius: 5px;
      border: none;
      font-size: 1.25rem;
      color: var(--text-colour);
      margin: 0.5rem;
      padding: 0.25rem;
    }
    button {
      background-color: var(--action-colour);
      color: var(--secondary-text-colour);
      padding: 0.5rem 2rem;
      border-radius: 5px;
      margin: 0 0.5rem;
      cursor: pointer;
    }
  }

  .currency {
    background-color: var(--primary-colour);
    box-shadow: var(--box-shadow);
    border: none;
    border-radius: 5px;
    font-size: 1rem;
    color: var(--text-colour);
    margin: 0.5rem 0.5rem;
    padding: 0.5rem 2rem;
  }

  .selected-currency {
    margin: 0.25rem;
  }

  .header {
    display: flex;
    flex-direction: column;
    background: var(--primary-colour);
    box-shadow: var(--box-shadow);
    border-radius: 10px;
    margin: 1rem;
    padding: 1rem;
    h4 {
      display: inline-block;
      margin: 1rem;
    }
    .detail {
      background-color: var(--tertiary-colour);
      box-shadow: var(--box-shadow);
      width: 95%;
      border: none;
      border-radius: 5px;
      font-size: 1.25rem;
      color: var(--text-colour);
      padding: 0.5rem;
      margin: 0.5rem;
    }
    .text {
      font-size: 1.25rem;
      color: var(--text-colour);
      background: none;
      border: none;
      border-radius: none;
      box-shadow: none;
      padding: 0.5rem;
      margin: 0.5rem;
    }
    .edit {
      cursor: pointer;
      margin: 0 5px;
    }
  }
}

.delete {
  background-color: var(--warning-colour);
  margin: 0.25rem;
  font-weight: light;
}

.active {
  color: var(--action-colour) !important;
}
.discon {
  color: var(--warning-colour) !important;
}

.icon {
  font-size: 1.5rem;
}

@media only screen and (orientation: portrait) {
  div.actions {
    padding: 3rem 1rem;
  }
  .payment_options {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    form {
      .header {
        span {
          .detail {
            width: 80%;
          }
        }
      }
      .section {
        display: flex;
        flex-direction: column;
        // align-items: flex-start;
        justify-content: center;
        width: 100%;

        ul{
          li{
            select{
              max-width: 80%;
            }
          }
        }
      }
      .currency {
        margin: 1rem;
      }
    }
  }
}
</style>
